export function TablerDiamondFilled(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="-5 -5 34 34"
      {...props}
    >
      {}
      <path
        fill="currentColor"
        stroke="var(--dark)"
        strokeWidth="10"
        paintOrder="stroke fill"
        d="M4.878 3.003h14.254a1 1 0 0 1 .809.412l3.822 5.256a.5.5 0 0 1-.037.633l-11.354 12.3a.5.5 0 0 1-.735 0L.283 9.305a.5.5 0 0 1-.037-.633l3.823-5.256a1 1 0 0 1 .809-.412"
      />
    </svg>
  );
}
